import { ChangeDetectionStrategy, Component, NO_ERRORS_SCHEMA, ViewChild } from '@angular/core';
import { DeviceBaseComponent } from '../../device-base/device-base.component';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-yealink-t53',
  templateUrl: './yealink-t53.component.html',
  styleUrls: ['../../device-base/device-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DeviceBaseComponent, NgClass, NgIf],
  schemas: [NO_ERRORS_SCHEMA],
})
export class YealinkT53Component {
  @ViewChild('base') base!: DeviceBaseComponent;

  public readonly buttonsLimit = 21;
}
